// extracted by mini-css-extract-plugin
export default {"tag":"tag__8H5kg"};